import {AbstractControl, ValidatorFn} from '@angular/forms';
import {AMEX, CODENSA, DINERS_CLUB, MASTERCARD, UNION_PAY, VISA} from '../core/constants/credit-cards.constants';

export class CreditCardValidator {

  static isValidCard(franchise: string): ValidatorFn {

    return (control: AbstractControl) => {
      const value = control.value;
      const re = CreditCardValidator.luhnAlgoritm(value);
      const franchiseNumber = CreditCardValidator.kindCard(value);
      const codensaFranchise = (franchiseNumber !== VISA.id &&
        franchiseNumber !== MASTERCARD.id &&
        franchiseNumber !== AMEX.id &&
        franchiseNumber !== DINERS_CLUB.id &&
        franchiseNumber !== UNION_PAY.id
      );
      if (re) {
        if (franchiseNumber === VISA.id && franchise === VISA.id) {
          return null;
        } else if (franchiseNumber === MASTERCARD.id && (franchise === MASTERCARD.id || franchise === CODENSA.id)) {
          return null;
        } else if (franchiseNumber === AMEX.id && franchise === AMEX.id) {
          return null;
        } else if (franchiseNumber === DINERS_CLUB.id && franchise === DINERS_CLUB.id) {
          return null;
        } else if (franchiseNumber === UNION_PAY.id && franchise === UNION_PAY.id) {
          return null;
        } else if (franchise === CODENSA.id && codensaFranchise) {
          return null;
        }
      }

      return {
        invalidCreditCardNumber: true
      };
    };
  }

  static luhnAlgoritm(value: string) {
    if (/[^0-9-\s]+/.test(value)) { return false; }

    let nCheck = 0;
    let bEven = false;
    value = value.replace(/\D/g, '');

    for (let n = value.length - 1; n >= 0; n--) {
      const cDigit = value.charAt(n);
      let nDigit = parseInt(cDigit, 10);

      if (bEven && (nDigit *= 2) > 9) { nDigit -= 9; }

      nCheck += nDigit;
      bEven = !bEven;
    }

    return (nCheck % 10) === 0;
  }

  static kindCard(numberCard: any): any {

    const match = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/.exec(numberCard);

    const types = ['visa', 'mastercard', 'discover', 'amex',
      'diners', 'jcb', 'union_pay'];

    if (match) {
      for (let i = 1; i < match.length; i++) {
        if (match[i]) {
          return types[i - 1];
        }
      }
    } else {
      return '';
    }
  }
}
